import {NgModule } from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import { 
    MatButtonModule,
    MatInputModule,
    MatExpansionModule,
    MatSidenavModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatProgressBarModule,
    MatTableModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatTabsModule,
    MatSelectModule,
    MatSortModule,
    MatCardModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatFormFieldModule
    

} from '@angular/material';


@NgModule({
    imports: [ 
        MatButtonModule,
        MatInputModule, 
        MatExpansionModule,
        MatSidenavModule,
        MatMenuModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        MatProgressBarModule,
        MatIconModule,
        MatTableModule,
        MatPaginatorModule,
        MatTooltipModule,
        MatTabsModule,
        MatSelectModule,
        MatSortModule,
        MatCardModule,
        MatSnackBarModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatFormFieldModule
    ],
    exports: [ 
        MatButtonModule,
        MatInputModule, 
        MatExpansionModule,
        MatSidenavModule,
        MatMenuModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        MatProgressBarModule,
        MatIconModule,
        MatTableModule,
        MatPaginatorModule,
        MatTooltipModule,
        MatTabsModule,
        MatSelectModule,
        MatSortModule,
        MatCardModule,
        MatSnackBarModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatFormFieldModule
    ]
})

export class MaterialModule{}